<template>
    <div style="margin-bottom: 72px">

        <!--        ***********************************************************************************************************-->
        <!--            SECTION INFORMATIONS DU DANSEUR-->
        <!--        ***********************************************************************************************************-->
        <h1>Ajout d'un danseur</h1>
        <h3 class="subtitle">{{ actualSection.title }}</h3>

        <section v-show="actualSection.name === 'infosDancer'" class="step-infos">
            <ValidationObserver ref="observer"
                                v-slot="{ invalid }"
                                tag="form"
                                @submit.prevent="submit()"
                                class="form-container"
            >
                <uni-input-container label="Prénom" for="firstname">
                    <uni-input rules="alpha_dash|required"
                               v-model="newDancer.firstname"
                               id="firstname"
                    />
                </uni-input-container>

                <uni-input-container label="Nom">
                    <uni-input rules="alpha_dash|required"
                               v-model="newDancer.name"
                               id="name"
                    />
                </uni-input-container>

                <uni-input-container label="Adresse" for="street">
                    <uni-input rules="required"
                               v-model="newDancer.street"
                               id="street"
                    />
                </uni-input-container>

                <uni-input-container label="Code postal"
                                     for="postalCode">
                    <uni-input rules="required|digits:5"
                               v-model="newDancer.postal_code"
                               id="postalCode"
                               mode="eager"
                    />
                </uni-input-container>

                <uni-input-container label="Ville" for="city">
                    <uni-input rules="required"
                               v-model="newDancer.city"
                               id="city"
                    />
                </uni-input-container>
              <uni-input-container label="Ville" for="city">
                <uni-input rules="required"
                           v-model="newDancer.city"
                           id="city"
                />
              </uni-input-container>
              <uni-input-container label="Date de naissance" for="birth-date">
                <uni-input rules="required"
                           v-model="newDancer.birth_date"
                           type="date"
                           id="birth-date"
                />
              </uni-input-container>

                <rich-yes-no-input question="Autorisez vous le droit à l'image"
                                   name="imageRight"
                                   v-model="newDancer.is_image_allowed"
                                   message="Si vous cochez « Non », vous ne pourrez pas participer au spectacle de fin d’année"
                />

                <div v-if="!newDancer.isMinor">
                    <uni-input-container label="Adresse e-mail" for="email">
                        <uni-input rules="required|email"
                                   v-model="newDancer.email"
                                   id="email"
                        />
                    </uni-input-container>
                    <uni-input-container label="Téléphone"
                                         for="tel"
                    >
                        <uni-input rules="required|digits:10"
                                   v-model="newDancer.tel"
                                   id="tel"
                        />
                    </uni-input-container>
                </div>
                <uni-button>Suivant</uni-button>
            </ValidationObserver>
        </section>


        <!--        ***********************************************************************************************************-->
        <!--            SECTION DES RESPONSABLES LEGAUX DU DANSEUR-->
        <!--        ***********************************************************************************************************-->


        <section v-show="actualSection.name === 'resps'" class="step-resp">
            <p>Sélectionner les responsables légaux</p>
            <rich-add-button @click.native.prevent="openSectionAddResp"
                             label="Créer un nouveau responsable"
            >

            </rich-add-button>
            <div>
                <ValidationObserver ref="respObserver"
                                    v-slot="{ invalid }"
                                    tag="form"
                                    class="form-container"
                                    @submit.prevent="submitResps()">
                    <validation-provider rules="required|checkResps"
                                         v-slot="{ errors, classes }"
                                         tag="div">
                        <uni-input-checkbox v-for="resp in resps"
                                            :index="resp.id"
                                            :label="resp.firstname+' '+resp.name"
                                            :id="resp.id"
                        >

                            <input type="checkbox"
                                   :id="resp.id"
                                   :value="resp.id"
                                   v-model="newDancer.resps"
                            >
                        </uni-input-checkbox>
                        <span>{{ errors[0] }}</span>
                    </validation-provider>
                    <div class="duo-button">
                        <uni-button @click.native.prevent="goBack(2)" class="button--secondary">
                            Précédent
                        </uni-button>
                        <uni-button>
                            Suivant
                        </uni-button>
                    </div>
                </ValidationObserver>
            </div>
        </section>


        <!--        ***********************************************************************************************************-->
        <!--            SECTION AJOUT D'UN RESPONSABLE LEGAL-->
        <!--        ***********************************************************************************************************-->


        <section class="add-resp">
            <pop-from-bottom :open="showSectionAddResp"
                             title="Ajout d'un responsable légal"
                             @close="showSectionAddResp = false"
            >
                <template slot="content">
                    <ValidationObserver ref="addRespObserver"
                                        v-slot="{ invalid }"
                                        tag="form"
                                        @submit.prevent="submitANewResp()"
                    >
                        <uni-input-container label="Prénom" for="firstname">
                            <uni-input rules="alpha_dash|required"
                                       v-model="newResp.firstname"
                                       id="firstname"
                            />
                        </uni-input-container>

                        <uni-input-container label="Nom">
                            <uni-input rules="alpha_dash|required"
                                       v-model="newResp.name"
                                       id="name"
                            />
                        </uni-input-container>

                        <uni-input-container label="Adresse" for="street">
                            <uni-input rules="required"
                                       v-model="newResp.street"
                                       id="street"
                            />
                        </uni-input-container>

                        <uni-input-container label="Code postal"
                                             for="postalCode">
                            <uni-input rules="required|digits:5"
                                       v-model="newResp.postal_code"
                                       id="postalCode"
                                       mode="eager"
                            />
                        </uni-input-container>

                        <uni-input-container label="Ville" for="city">
                            <uni-input rules="required"
                                       v-model="newResp.city"
                                       id="city"
                            />
                        </uni-input-container>

                        <uni-input-container label="Adresse e-mail" for="email">

                            <uni-input rules="required|email"
                                       v-model="newResp.email"
                                       id="email"
                            />
                        </uni-input-container>
                        <uni-input-container label="Téléphone"
                                             for="tel"
                        >
                            <uni-input rules="required|digits:10"
                                       v-model="newResp.tel"
                                       id="tel"
                            />
                        </uni-input-container>

                        <input-birthday v-model="newResp.birth_date" id="birthDateResp"></input-birthday>

                        <rich-yes-no-input question="Cette personne danse ?"
                                           name="isNewRespDancing"
                                           v-model="newResp.is_dancer"
                        />
                        <div v-if="newResp.is_dancer">
                            <rich-yes-no-input question="Autorisez vous le droit à l'image"
                                               name="respImageRight"
                                               v-model="newResp.is_image_allowed"
                                               message="Si vous cochez « Non », vous ne pourrez pas participer au spectacle de fin d’année"
                            />
                        </div>
                        <uni-button @click.native="createNewResp">Ajouter le responsable légal</uni-button>
                    </ValidationObserver>
                </template>
            </pop-from-bottom>
        </section>


        <!--        ***********************************************************************************************************-->
        <!--            SECTION AJOUT DU CERTIFICAT MEDICAL -->
        <!--        ***********************************************************************************************************-->


        <section v-show="actualSection.name === 'certificate'" class="step-certificate">
            <p>Prenez en photo ou télécharger votre certificat médical.</p>
            <input-file id="addCertificate" ref="file" @change="updateFile">

            </input-file>
            <p class="card">
                <strong>Vous n'avez pas encore votre certificat médical ?</strong><br>
                Vous pourrez l'ajouter plus tard.<br> Cliquez sur "Ajouter {{ newDancer.firstname }}" .
            </p>
            <div class="duo-button">
                <uni-button @click.native.prevent="goBack(2)" class="button--secondary">
                    Précédent
                </uni-button>
                <uni-loading-button style="width: auto;" :is-disable="loading" :text="'Ajouter '+ newDancer.firstname"
                                    @click.native="submitNewDancer">
                </uni-loading-button>
            </div>
        </section>
    </div>
</template>

<script>
    import RichHeaderSecondaryLevel from "../../components/c-blocks/RichHeaderSecondaryLevel";
    import UniInput from "../../components/a-elements/UniInput";
    import UniInputContainer from "../../components/a-elements/UniInputContainer";
    import UniInputDate from "../../components/a-elements/UniInputDate";
    import RichYesNoInput from "../../components/a-elements/RichYesNoInput";
    import UniButton from "../../components/a-elements/UniButton";
    import UniInputCheckbox from "../../components/a-elements/UniInputCheckbox";
    import UniCtaLink from "../../components/a-elements/UniCtaLink";
    import PopFromBottom from "../../components/c-blocks/PopFromBottom";
    import InputFile from "../../components/a-elements/InputFile";
    import {mapGetters} from "vuex";
    import RichAddButton from "../../components/a-elements/RichAddButton";
    import InputBirthday from "../../components/a-elements/InputBirthday";
    import UniLoadingButton from "../../components/b-patterns/UniLoadingButton";

    export default {
        name: "new",
        components: {
            InputBirthday,
            UniLoadingButton,
            RichAddButton,
            InputFile,
            PopFromBottom,
            UniCtaLink,
            UniInputCheckbox,
            UniButton, RichYesNoInput, UniInputDate, UniInputContainer, UniInput, RichHeaderSecondaryLevel
        },
        data() {
            return {
                showSectionAddResp: false,
                actualSection: {
                    name: 'infosDancer',
                    title: 'Étape 1 : informations générales',
                },
                certificate: null,
                family: [],
                loading: false,
                newDancer: {
                    name: "",
                    firstname: "",
                    email: "",
                    tel: "",
                    is_dancer: true,
                    birth_date: null,
                    is_image_allowed: null,
                    street: "",
                    postal_code: "",
                    city: "",
                    isMinor: true,
                    resps: []
                },
                newResp: {
                    name: "",
                    firstname: "",
                    email: "",
                    tel: "",
                    is_dancer: null,
                    birth_date: null,
                    is_image_allowed: '',
                    tel: "",
                    street: "",
                    postal_code: "",
                    city: "",
                    isNewRespDancing: false
                },
                resps: []
            }
        },
        watch: {
            birthDate: function (val) {
                this.newDancer.isMinor = this.$getAge(val) <= 18
                if (!this.newDancer.isMinor && this.newDancer.resps.length !== 0) {
                    while (this.newDancer.resps.length) {
                        this.newDancer.resps.pop()
                    }
                }
            }
        },
        computed: {
            birthDate() {
                return this.newDancer.birth_date
            },
            ...mapGetters({
                currentFamily: 'currentFamily'
            })
        },
        methods: {
            createNewResp() {
                const user = {
                    user: {
                        ...this.newResp,
                        family_id: this.currentFamily.id
                    }
                }

                this.$createModel('users', user)
                    .then(data => {
                        this.resps.push(data)
                    })

            },
            userLoggedIn() {
                if (this.currentFamily === null) {
                    this.router.push('/connexion')
                }
            },
            updateFile(e) {
                this.certificate = e.target
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if (!isValid) {
                    // ABORT!!
                    console.log('Form is uncomplete')
                } else {
                    console.log('Form submit')
                    console.log(this.newDancer.isMinor)
                    if (this.newDancer.isMinor) {
                        this.actualSection.name = 'resps'
                        this.actualSection.title = 'Étape 2 : responsables légaux'
                    } else {
                        this.actualSection.name = 'certificate'
                        this.actualSection.title = 'Étape finale : certificat médical'
                    }
                }
            },


            async submitANewResp() {
                const isValid = await this.$refs.addRespObserver.validate();
                if (!isValid) {
                    // ABORT!!
                    console.log('Form for new resp is uncomplete')
                } else {
                    // 🐿 ship it
                    console.log('New Resp submit')
                    this.showSectionAddResp = false
                }
            },

            async submitResps() {
                const isValid = await this.$refs.respObserver.validate();
                if (!isValid) {
                    // ABORT!!
                    console.log('Checkbox uncomplete')
                } else {
                    // 🐿 ship it
                    this.actualSection.name = 'certificate'
                    this.actualSection.title = 'Étape finale : certificat médical'
                }
            },

            async submitNewDancer() {

                this.loading = true
                let dancer = {
                    user: {
                        ...this.newDancer,
                        family_id: this.currentFamily.id
                    },
                    resps: this.newDancer.resps
                }


                this.$createModel('users', dancer)
                    .then(data => {
                        if (this.certificate) {
                            const image = {
                                'certificate': this.certificate.files[0]
                            }

                            let formData = new FormData()

                            Object.entries(image).forEach(
                                ([key, value]) => formData.append(key, value)
                            )
                            this.$createCertificate(data.id, formData)
                                .then(request => {

                                })
                        } else {
                            this.$router.push({name: 'users.success', params: {id: data.id}})
                        }


                    })


                // 🐿 ship it
                // const params = {
                //     'avatar': this.inputAvatar
                // }
                //
                // let formData = new FormData()
                //
                // Object.entries(params).forEach(
                //     ([key, value]) => formData.append(key, value)
                // )
                // this.loading = true
                //
                // this.$http.put('users/' + this.currentUser.id, formData, {
                //     headers: {
                //         'Authorization': 'Bearer ' + localStorage.token
                //     }
                // })
                //     .then(result => {
                //         this.updateStore(result.default_picture, result.profile_picture)
                //         this.loading = false
                //
                //         this.$emit('updateProfile', e.target)
                //     })

            },


            goBack(index) {
                if (index === 2 || !this.newDancer.isMinor) {
                    this.actualSection.name = 'infosDancer'
                    this.actualSection.title = 'Étape 1 : informations générales'
                } else {
                    this.actualSection.name = 'resps'
                    this.actualSection.title = 'Étape 2 : responsables légaux'
                }
            },

            openSectionAddResp() {
                this.showSectionAddResp = true
            }
        },
        created() {
            this.userLoggedIn()
            this.$getModel('families', this.currentFamily.id)
                .then(data => {
                    this.family = data
                    this.$nextTick(() => {
                        let adults = this.family.users.filter(el => this.$getAge(el.birth_date) >= 18)
                        this.newDancer.postal_code = adults[0].postal_code
                        this.newDancer.city = adults[0].city
                        this.newDancer.street = adults[0].street


                        this.resps = adults
                    })
                })
        }
    }
</script>

<style scoped lang="scss">

    .form-container {
        max-width: 400px;
    }

    .subtitle {
        margin: 16px 0;
    }

    .card {
        margin-top: 1rem;
    }

    @include screen-m {
        .duo-button {
            position: initial;
        }

        .card {
            width: auto;
        }


    }
</style>
